import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../../i18n/components/T.js'

export const NewMessageDivider = () => {
  return (
    <div className="w-full py-4 px-2 sm:px-8">
      <Divider padding="none">
        <Text variant="bodySm" className="text-content-subdued">
          <T id="Messaging.NewMessages" defaultMessage="New messages" />
        </Text>
      </Divider>
    </div>
  )
}
